import { defineComponent, ref } from "vue";
import { Category } from "@app/types/index";
import { useMenu } from "@app/vue/providers/Menu";
import { CategoryMenu } from "./components/CategoryMenu";
import { CategoryList } from "./components/CategoryList";
import { SearchIcon } from "./components/SearchIcon";
import { useLocalization } from "@lemmonhq/uikit";

export type MenuHeaderProps = {
  categories: Category[];
  activeCategory: number | null;
};

export const MenuHeader = defineComponent<MenuHeaderProps>({
  name: "MenuHeader",
  props: ["categories", "activeCategory"],
  setup(props) {
    const { searchQuery } = useMenu();
    const { t } = useLocalization();
    const isSearchActive = ref(false);

    const scrollToCategory = (categoryId: number) => {
      const categoryEl = document.querySelector(
        `[data-category="${categoryId}"]`,
      ) as HTMLElement;
      if (categoryEl) {
        categoryEl.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    };

    const handleSearchToggle = () => {
      isSearchActive.value = !isSearchActive.value;
      if (!isSearchActive.value) {
        searchQuery.value = "";
      }
    };

    return () => (
      <div class="sticky top-[59px]  bg-base-200 shadow-lg h-14 flex flex-col justify-center">
        <div class="flex items-center">
          {isSearchActive.value ? (
            // Search mode - full width search input
            <div class="flex-1 flex items-center gap-2 px-2">
              <div class="flex-1">
                <label class="input input-md input-bordered flex items-center gap-2">
                  <span class="material-symbols-outlined text-xl">search</span>
                  <input
                    type="text"
                    v-model={searchQuery.value}
                    placeholder={t("customer.shop_menu.search_placeholder")}
                    class="grow"
                    autofocus
                  />
                </label>
              </div>
              <button
                onClick={handleSearchToggle}
                class="btn btn-circle btn-ghost"
              >
                <span class="material-symbols-outlined text-xl">close</span>
              </button>
            </div>
          ) : (
            // Normal mode
            <>
              <CategoryMenu
                categories={props.categories}
                onCategorySelect={scrollToCategory}
              />
              <CategoryList
                categories={props.categories}
                activeCategory={props.activeCategory}
                onCategorySelect={scrollToCategory}
              />
              <SearchIcon onSearchToggle={handleSearchToggle} />
            </>
          )}
        </div>
      </div>
    );
  },
});
